import {
  BaseNav,
  buildNavItemFromRoute,
  RouteAuthenticationRequirement,
  RouteItem,
  useAuth
} from '@cksoftware/react-base';
import { DlmsUser } from '../../globalModels/user/dlmsUser.ts';
import { BaseNavItem } from '@cksoftware/react-base/dist/BaseComponents/Nav/types';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { Bleed, Box, Stack, type StackProps } from '@chakra-ui/react';
import { SidebarLink } from './sidebar-link.tsx';
import NavItem = BaseNav.NavItem;

interface SidebarNavProps extends StackProps {
  items: RouteItem[];
}

export const SidebarNavItems = (props: SidebarNavProps) => {
  const auth = useAuth<DlmsUser>();

  const links = props.items
    .map((route) => buildNavItemFromRoute(route))
    .filter(
      (navItem): navItem is BaseNavItem =>
        navItem !== undefined &&
        (navItem.disableDefaultRender === undefined || !navItem.disableDefaultRender) &&
        (navItem.authenticationRequirement !== RouteAuthenticationRequirement.Authenticated || auth.isAuthenticated)
    );

  const nav = useNavigate();

  const onNavClick = useCallback(
    (navItem: NavItem, event: React.MouseEvent) => {
      // Prevent default navigation for normal clicks to preserve SPA routing
      // but allow right-click, middle-click, and Ctrl+click for new tab functionality
      if (!event.ctrlKey && !event.metaKey && event.button === 0) {
        event.preventDefault();
      }

      if (navItem.onClick) {
        navItem.onClick();
      }
      if (navItem.path && !event.ctrlKey && !event.metaKey && event.button === 0) {
        nav(navItem.path);
      }
    },
    [nav]
  );

  return (
    <Stack gap='2' width={'224px'}>
      {links.map((link, index) => (
        <Bleed key={index} inline='4'>
          <SidebarLink
            disabled={!!link.subItems}
            icon={link.icon}
            linkStyle={link.textStyle}
            href={link.path}
            onClick={(event) => onNavClick(link, event)}
            aria-current={link.path && window.location.pathname.indexOf(link.path) >= 0 ? 'page' : undefined}>
            {link.text}
          </SidebarLink>
          {link.subItems &&
            link.subItems.map((link, subLinkIndex) => (
              <Box key={subLinkIndex} ml='4'>
                <SidebarLink
                  icon={link.icon}
                  linkStyle={link.textStyle}
                  href={link.path}
                  onClick={(event) => onNavClick(link, event)}
                  aria-current={link.path && window.location.pathname.indexOf(link.path) >= 0 ? 'page' : undefined}>
                  {link.text}
                </SidebarLink>
              </Box>
            ))}
        </Bleed>
      ))}
    </Stack>
  );
};
